<template>
  <div class="payment-cancel">
    <div class="cancel-container">
      <div class="content-wrapper">
        <div class="cancel-content">
          <div class="cancel-icon">
            <span class="material-icons-outlined">cancel</span>
          </div>
          
          <h1>{{ $t('paymentCancel.title') }}</h1>
          <p class="description">{{ $t('paymentCancel.description') }}</p>

          <div class="buttons">
            <button @click="backToHome" class="btn btn-outline">
              {{ $t('paymentCancel.buttons.backToHome') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentCancel',
  methods: {
    backToHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.payment-cancel {
  margin-top: var(--navbar-height);
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.7), rgba(246, 248, 251, 0.96)),
    var(--color-page);
  padding: 2rem;
}

.cancel-container {
  background: var(--workspace-shell-bg);
  border: 1px solid var(--workspace-shell-border);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 600px;
  box-shadow: var(--workspace-shell-shadow);
}

.content-wrapper {
  padding: 3rem;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-content {
  width: 100%;
  text-align: center;
}

.cancel-icon {
  width: 4rem;
  height: 4rem;
  margin-bottom: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-xl);
  background: var(--color-danger-bg);
  color: var(--color-danger);
  animation: scale-in 0.5s ease-out;
}

.cancel-icon .material-icons-outlined {
  font-size: 2.65rem;
}

h1 {
  color: var(--color-text);
  font-size: clamp(2rem, 5vw, 2.5rem);
  margin-bottom: 0.75rem;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.description {
  color: var(--color-text-subtle);
  font-size: 1.1rem;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

.btn {
  min-height: 44px;
  padding: 0 1.35rem;
  border-radius: var(--radius-pill);
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-outline {
  background: transparent;
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

.btn-outline:hover {
  background: var(--color-text);
  color: var(--color-text-inverse);
  transform: translateY(-1px);
}

@keyframes scale-in {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 640px) {
  .content-wrapper {
    padding: 2rem;
    min-height: 300px;
  }

  .buttons {
    flex-direction: column;
  }

  h1 {
    font-size: 2rem;
  }

  .description {
    font-size: 1rem;
  }
}
</style>
